import { addElementAfter } from '../modules/forms'


const selectsDOM = document.querySelectorAll('.form-select select')
selectsDOM.forEach(s => addElementAfter(s, '.icon'))